import React from "react"
import { Link } from "react-router-dom"

import { useStyles } from "@/components/ProfileSection/RoleInfo/RoleInfo.styles"

export const RoleInfo = ({
    roleInfo,
}: {
    roleInfo: { title?: string; subtitle?: string; displayValue?: string; segueUrl?: string }
}) => {
    const { classes } = useStyles()

    const renderValue = () => {
        if (roleInfo.segueUrl) {
            return <Link to={roleInfo.segueUrl}>{roleInfo.displayValue}</Link>
        }

        return roleInfo.displayValue
    }

    return (
        <div className={classes.roleInfo}>
            <div className={classes.mainInfo}>
                {roleInfo.title && <div className={classes.title}>{roleInfo.title}</div>}
                {roleInfo.displayValue && <div className={classes.value}>{renderValue()}</div>}
            </div>
            {roleInfo.subtitle && <div className={classes.subtitle}>{roleInfo.subtitle}</div>}
        </div>
    )
}
